import React from "react";
// redux
import { useSelector } from "react-redux";
//react components for routing our app without refresh
// import { useParams } from "react-router";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
import { useParams, Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
// core components
import Button from "components/CustomButtons/Button.js";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/profilePage.js";

const useStyles = makeStyles(styles);

export default function UserDetailPage() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgCard,
    classes.imgRaised,
    classes.imgRoundedCircle
  );

  const { username } = useParams();
  const viewUser = useSelector(
    (state) => state.users.filter((user) => user.username === username)[0]
  );
  const auth = useSelector((state) => state.auth);

  var renderer;
  if (auth.user.username === username) {
    renderer = (
      <Grid
        container
        spacing={3}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={6}>
          <Link to="/users/editprofile">
            <Button round color="info">
              Edit Profile
            </Button>
          </Link>
        </Grid>
      </Grid>
    );
  } else {
    renderer = <div></div>;
  }

  return (
    <div>
      <Header
        color="transparent"
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
      />
      <Parallax small filter image={require("assets/img/profile-bg.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem xs={12}>
              <div className={classes.profile}>
                <div>
                  <img
                    src={viewUser?.imageId}
                    alt="..."
                    className={imageClasses}
                    height="150"
                    width="100"
                  />
                </div>
                <div className={classes.name}>
                  <h3 className={classes.title}>{"@" + viewUser?.username}</h3>
                </div>
                <h6>{viewUser?.isAdmin ? "ADMIN" : "USER"}</h6>
                <h3 className={classes.title}>{viewUser?.fullName}</h3>
                <h3>
                  <Email /> {viewUser?.email}
                </h3>
                <h3>
                  <PhoneIcon />{" "}
                  {viewUser?.contactNumber ? viewUser?.contactNumber : "-"}
                </h3>
              </div>
            </GridItem>
          </GridContainer>
          <br />
          {renderer}
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}
